import { useEffect, useState } from "react";

import { Label, LabelTheme, labelThemeOptions } from "../../../components";

//renders up to four labels at a time that periodically transition between options
export const Labels = ({ options }: { options: readonly string[] }) => {
    const VISIBLE_LABEL_COUNT = 4;
    const LABEL_ROTATION_TIMEOUT = 7000;

    const initialLabels = options
        .slice(0, VISIBLE_LABEL_COUNT)
        .map((text, index) => ({
            text,
            theme: labelThemeOptions[index] as LabelTheme
        }));

    const [currentLabels, setCurrentLabels] = useState(initialLabels);

    const [labelCounter, setLabelCounter] = useState(0);

    //periodically rotate
    useEffect(() => {
        const timer = setTimeout(() => {
            const newLabel = {
                text:
                    options[
                        (labelCounter + VISIBLE_LABEL_COUNT) % options.length
                    ] ?? "",
                theme: labelThemeOptions[
                    (labelCounter + VISIBLE_LABEL_COUNT) %
                        labelThemeOptions.length
                ] as LabelTheme
            };
            currentLabels.splice(
                labelCounter % VISIBLE_LABEL_COUNT,
                1,
                newLabel
            );
            setLabelCounter(labelCounter + 1);
            setCurrentLabels([...currentLabels]);
        }, LABEL_ROTATION_TIMEOUT);
        return () => clearTimeout(timer);
    }, [
        currentLabels,
        labelCounter,
        LABEL_ROTATION_TIMEOUT,
        VISIBLE_LABEL_COUNT,
        options
    ]);

    return (
        <>
            {currentLabels.map(({ text, theme }, index) => (
                <Label
                    className={`label label-${index}`}
                    key={index}
                    text={text}
                    theme={theme}
                />
            ))}
        </>
    );
};
